import { editorSearch } from '@/stateManagement';
import constants from '@/constants';

import type { StateMapperArgs } from 'types/redux';

export const mapStateToProps = ({ editorAPI }: StateMapperArgs) => ({
  isOpen: editorSearch.selectors.isPanelOpen(editorAPI.store.getState()),
  openOrigin: editorSearch.selectors.getPanelOpenOrigin(
    editorAPI.store.getState(),
  ),
  authorizationToken: editorAPI.dsRead
    ? editorAPI.dsRead.platform.getAppDataByApplicationId(
        constants.APPLICATIONS.META_SITE_APPLICATION_ID,
      ).instance
    : null,
});

export const mapDispatchToProps = (dispatch: FunctionFixMe) => ({
  closeSearch() {
    dispatch(editorSearch.actions.closeEditorSearchPanel());
  },
});
